const BASE_URL = import.meta.env.VITE_API_URL;
const PARKER_API_BASE = `${BASE_URL}/api/parker`;
const VEHICLE_API_BASE = `${BASE_URL}/api/vehicle`;
const LOCATION_API_BASE = `${BASE_URL}/api/locations`;
const SUBSCRIPTION_API_BASE = `${BASE_URL}/api/subscription`;
const CARD_API_BASE = `${BASE_URL}/api/card`;
const OPERATOR_API_BASE = `${BASE_URL}/api/operator`;
const USER_API_BASE = `${BASE_URL}/api/user`;
const MULTIFAMILY_API_BASE = `${BASE_URL}/api/multifamily`;
const DASHBOARD_API_BASE = `${BASE_URL}/api/dashboard`;
const LPR_API_BASE = `${BASE_URL}/api/lpr`;

export const API_URL = {
    // Parker API
    SEND_OTP: `${PARKER_API_BASE}/send-otp`,
    RESEND_OTP: `${PARKER_API_BASE}/resend-otp`,
    VERIFY_OTP: `${PARKER_API_BASE}/verify-otp`,
    REGISTER_DETAILS: `${PARKER_API_BASE}/register-details`,
    ADD_VEHICLE: `${PARKER_API_BASE}/add-vehicle`,
    LOGIN: `${PARKER_API_BASE}/login`,
    FORGOT_PASSWORD_SEND_OTP: `${PARKER_API_BASE}/forgot-password/send-otp`,
    FORGOT_PASSWORD_VERIFY_OTP: `${PARKER_API_BASE}/forgot-password/verify-otp`,
    RESET_PASSWORD: `${PARKER_API_BASE}/reset-password`,
    GET_CURRENT_PARKER: `${PARKER_API_BASE}/current/parker`,

    // Vehicles routes
    GET_VEHICLES: `${VEHICLE_API_BASE}/all`,
    CREATE_VEHICLE: `${VEHICLE_API_BASE}/create`,
    GET_VEHICLE_BY_ID: (id) => `${VEHICLE_API_BASE}/${id}`,
    UPDATE_VEHICLE: (id) => `${VEHICLE_API_BASE}/update/${id}`,
    DELETE_VEHICLE: (id) => `${VEHICLE_API_BASE}/delete/${id}`,

    // Locations routes
    GET_LOCATIONS: `${LOCATION_API_BASE}/get/all`,
    GET_LOCATION_BY_ID: (id) => `${LOCATION_API_BASE}/get/single/${id}`,
    GET_SINGLE_AVAILABLE_LOCATION: (id) => `${LOCATION_API_BASE}/get/available-location/${id}`,
    GET_LOCATION_BY_NEARBY_LOCATION_ID: (id) => `${LOCATION_API_BASE}/get/nearby/${id}`,
    CREATE_LOCATION: `${LOCATION_API_BASE}/create`,
    UPDATE_LOCATION: (id) => `${LOCATION_API_BASE}/update/${id}`,
    DELETE_LOCATION: (id) => `${LOCATION_API_BASE}/delete/${id}`,
    GET_NEARBY_LOCATIONS: `${LOCATION_API_BASE}/get/nearby`,
    GET_RECURRING_RATES: (id) => `${LOCATION_API_BASE}/get/recurring-rates/${id}`,
    GET_FILTERED_LOCATIONS: `${LOCATION_API_BASE}/get/filtered-locations`,
    GET_AVAILABLE_LOCATIONS: `${LOCATION_API_BASE}/get/available-for-subscription`,

    //Parkers Admin
    GET_ALL_PARKERS: `${PARKER_API_BASE}/all`,
    GET_PARKER_BY_ID: `${PARKER_API_BASE}`,
    DELETE_PARKER: `${PARKER_API_BASE}/delete`,
    UPDATE_PARKER_BY_ID: `${PARKER_API_BASE}/update`,

    // New Admin Routes for Group Parker Management
    UPDATE_GROUP_PARKER_BY_ID: (id) => `${PARKER_API_BASE}/group/update/${id}`,
    CREATE_GROUP_PARKER: `${PARKER_API_BASE}/group/create`,
    GET_ALL_PARKERS_OF_GROUP_ADMIN: `${PARKER_API_BASE}/group/all`,
    GET_ALL_PARKERS_OF_GROUP_ADMIN_EXCEL: `${PARKER_API_BASE}/group/excel`,
    DELETE_PARKER_OF_GROUP_ADMIN: (id, subscriptionId) =>
        `${PARKER_API_BASE}/group/delete/${id}?subscriptionId=${subscriptionId}`,
    GET_GROUP_ADMIN_PARKER_BY_ID: (id) => `${PARKER_API_BASE}/group/${id}`,

    // Account Settings Routes
    UPDATE_PROFILE: `${PARKER_API_BASE}/profile/update`,
    UPDATE_PASSWORD: `${PARKER_API_BASE}/password/update`,

    // Admin
    UPDATE_USER: (id) => `${USER_API_BASE}/edit/${id}`,

    // current user
    GET_CURRENT_USER: `${USER_API_BASE}/me`,

    // Subscription routes
    PARKER_SUBSCRIPTION_FOR_ADMIN: `${SUBSCRIPTION_API_BASE}/parker-subscriptions-for-admin`,
    GET_PARKER_PAYMENTS_ADMIN: `${SUBSCRIPTION_API_BASE}/parker-payments`,
    CREATE_SUBSCRIPTION: `${SUBSCRIPTION_API_BASE}/create`,
    MANAGE_UPDATE_SUBSCRIPTION: `${SUBSCRIPTION_API_BASE}/manage-update-subscription`,
    GET_SUBSCRIPTION_BY_USER_ID: (id) => `${SUBSCRIPTION_API_BASE}/get/by-user/${id}`,
    UPDATE_SUBSCRIPTION: (id) => `${SUBSCRIPTION_API_BASE}/update/${id}`,
    DELETE_SUBSCRIPTION: (id) => `${SUBSCRIPTION_API_BASE}/delete/${id}`,
    GET_ACTIVE_SUBSCRIPTIONS: `${SUBSCRIPTION_API_BASE}/active`,
    GET_PREVIOUS_SUBSCRIPTIONS: `${SUBSCRIPTION_API_BASE}/previous`,
    // For fetching available locations for subscription
    CANCEL_SUBSCRIPTION: (id) => `${SUBSCRIPTION_API_BASE}/cancel/${id}`,
    REJECT_SUBSCRIPTION: (id) => `${SUBSCRIPTION_API_BASE}/reject/${id}`,
    GET_SUBSCRIPTION_TYPES: `${SUBSCRIPTION_API_BASE}/get/subscription-types`,
    GET_SUBSCRIPTION_BY_LOCATION_ID: (id) => `${SUBSCRIPTION_API_BASE}/get/by-location/${id}`,
    RE_SUBSCRIBE: (id) => `${SUBSCRIPTION_API_BASE}/re-subscribe/${id}`,
    GET_SUBSCRIPTION_BY_ID: (id) => `${SUBSCRIPTION_API_BASE}/${id}`,
    GET_SUBSCRIPTION_BY_USER_AND_LOCATION_IDS: (userId, locationId) =>
        `${SUBSCRIPTION_API_BASE}/get/by-user-and-location/${userId}/${locationId}`,

    // Group admin subscriptions routes
    GET_GROUP_ADMIN_SUBSCRIPTION_BY_ID: (id) => `${SUBSCRIPTION_API_BASE}/group-admin/${id}`,
    GET_INVITED_PARKER_PENDING_SUBSCRIPTIONS: (id) => `${SUBSCRIPTION_API_BASE}/group-subscription/parker/${id}`,
    ACTIVATE_GROUP_SUBSCRIPTIONS_OF_PARKER: (id) => `${SUBSCRIPTION_API_BASE}/group-subscription/activate/parker/${id}`,

    // Card routes
    ADD_CARD: `${CARD_API_BASE}/add`,
    GET_CARDS: `${CARD_API_BASE}/list`,
    DELETE_CARD: (cardId) => `${CARD_API_BASE}/delete/${cardId}`,
    SET_DEFAULT_CARD: `${CARD_API_BASE}/default`,
    GET_DEFAULT_CARD: `${CARD_API_BASE}/get/default`,

    // Operator API
    OPERATOR_SEND_OTP: `${OPERATOR_API_BASE}/send-otp`,
    OPERATOR_VERIFY_OTP: `${OPERATOR_API_BASE}/verify-otp`,
    OPERATOR_REGISTER_DETAILS: `${OPERATOR_API_BASE}/register-details`,
    OPERATOR_GET_ALL: `${OPERATOR_API_BASE}/all`,
    OPERATOR_GET_BY_ID: (id) => `${OPERATOR_API_BASE}/${id}`,
    OPERATOR_UPDATE_PROFILE: `${OPERATOR_API_BASE}/profile/update`,
    OPERATOR_UPDATE_PASSWORD: `${OPERATOR_API_BASE}/password/update`,
    OPERATOR_DELETE: (id) => `${OPERATOR_API_BASE}/delete/${id}`,
    RESET_PASSWORD_OPERATOR: (id) => `${USER_API_BASE}/operator/reset-password/${id}`,
    // Group Admin API
    CREATE_GROUP_ADMIN: `${USER_API_BASE}/group-admin/create`,
    GET_GROUP_ADMINS: `${USER_API_BASE}/group-admin/all`,
    GET_GROUP_ADMIN_BY_ID: (id) => `${USER_API_BASE}/group-admin/${id}`,
    UPDATE_GROUP_ADMIN: (id) => `${USER_API_BASE}/group-admin/update/${id}`,
    RESET_PASSWORD_GROUP_ADMIN: (id) => `${USER_API_BASE}/group-admin/reset-password/${id}`,
    DELETE_GROUP_ADMIN: (id) => `${USER_API_BASE}/group-admin/delete/${id}`,
    GET_GROUP_ADMINS_EXCEL: `${USER_API_BASE}/group-admin/excel`,
    GROUP_ADMIN_LOGIN: `${USER_API_BASE}/login/email`,
    GET_GROUP_ADMIN_SUBSCRIPTION_DETAIL_BY_ID: (groupAdminId, subscriptionId) =>
        `${SUBSCRIPTION_API_BASE}/group-admin/details/${groupAdminId}/${subscriptionId}`,
    GET_GROUP_ADMIN_PARKERS_BY_SUBSCRIPTION_ID: (groupAdminId, subscriptionId) =>
        `${SUBSCRIPTION_API_BASE}/group-admin/details/parkers/${groupAdminId}/${subscriptionId}`,

    // Invoices
    GET_ALL_GROUP_ADMIN_INVOICES: `${USER_API_BASE}/group-admin/invoices`,
    GET_ALL_GROUP_ADMIN_INVOICES_EXCEL: `${USER_API_BASE}/group-admin/invoices/excel`,
    GET_INVOICE_BY_ID: (id) => `${USER_API_BASE}/group-admin/invoice/${id}`,
    POST_PAYMENT_INVOICE_BY_ID: (id) => `${USER_API_BASE}/group-admin/post-payment/${id}`,

    // Operator Routes

    ADD_OPERATOR: `${USER_API_BASE}/operator/add`,
    UPDATE_OPERATOR: (id) => `${USER_API_BASE}/operator/update/${id}`,
    DELETE_OPERATOR: (id) => `${USER_API_BASE}/operator/delete/${id}`,
    GET_OPERATORS: `${USER_API_BASE}/operators`,
    GET_OPERATOR_BY_ID: (id) => `${USER_API_BASE}/operator/${id}`,
    OPERATOR_LOGIN: `${USER_API_BASE}/login/operator`,

    ADD_GROUP_STAFF: `${USER_API_BASE}/group-staff/add`,
    UPDATE_GROUP_STAFF: (id) => `${USER_API_BASE}/group-staff/update/${id}`,
    DELETE_GROUP_STAFF: (id) => `${USER_API_BASE}/group-staff/delete/${id}`,
    GET_GROUP_STAFFS: `${USER_API_BASE}/group-staff`,
    GET_GROUP_STAFF_BY_ID: (id) => `${USER_API_BASE}/group-staff/${id}`,
    GROUP_STAFF_LOGIN: `${USER_API_BASE}/login/group-staff`,

    // Multifamily
    MULTIFAMILY: {
        VALIDATE_ACCESS_CODE: `${MULTIFAMILY_API_BASE}/validate-access-code`
    },

    // Dashboard API
    GET_ACTIVE_PARKER_SUBSCRIPTIONS: (id) => `${DASHBOARD_API_BASE}/active-parker-subscriptions/${id}`,
    GET_PENDING_PARKER_SUBSCRIPTIONS: (id) => `${DASHBOARD_API_BASE}/pending-parker-subscriptions/${id}`,
    GET_BALANCE_ACCOUNT_CHARGES: (id) => `${DASHBOARD_API_BASE}/balance-account-charges/${id}`,
    GET_SUBSCRIPTION_GRAPH_DATA: (id) => `${DASHBOARD_API_BASE}/subscription-graph-data/${id}`,
    GET_PAYMENT_GRAPH_DATA: (id) => `${DASHBOARD_API_BASE}/payment-graph-data/${id}`,

    // LPR
    GET_ALL_LPRS: `${LPR_API_BASE}/all-lprs`,
    GET_LPR_BY_ID: `${LPR_API_BASE}`
};
